import { apiClient, basicApiClient } from 'MainApp';

export const unauthenticatedApi = () => basicApiClient;
export default () => apiClient;
